
import {useMemo} from 'react';

import {MapProps} from '.';

type MapInit = MapProps['init']

export const useParseCoords = (coords?: string, zoom?: string): MapInit => {
	const valid = useMemo(() => {
		const parse = coords?.split(',').map((c) => Number(c.trim()));
		if (!parse || parse.length !== 2) {
			return undefined;
		} else if (parse.some((c) => isNaN(c))) {
			return undefined;
		} else if (parse[0] < -180 || parse[0] > 180) {
			return undefined;
		} else if (parse[1] < -90 || parse[1] > 90) {
			return undefined;
		}
		return parse;
	}, [coords]);

	return useMemo(() => {
		return {
			coords: valid,
			zoom: Number(zoom),
		};
	}, [valid, zoom]);
};
